import React, { FC } from 'react';
import styled from '@emotion/styled';

const Base = styled.button`
  color: white;
  border-radius: 4px;
  text-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
`;

const Success = styled(Base)`
  background: rgb(28, 184, 65);
`;

const Error = styled(Base)`
  background: rgb(202, 60, 60);
`;

const Warning = styled(Base)`
  background: rgb(223, 117, 20);
`;

const Secondary = styled(Base)`
  background: rgb(66, 184, 221);
`;

interface ButtonProps {
  variant?: 'success' | 'error' | 'warning' | 'secondary'
}

const fromVariant = (variant: 'success' | 'error' | 'warning' | 'secondary') => {
  return {
    'success': Success,
    'error': Error,
    'secondary': Secondary,
    'warning': Warning
  }[variant] || Base;
};

export const Button: FC<ButtonProps> = ({ variant = 'success', ...rest }) => {
  const Component = fromVariant(variant);
  return <Component className="pure-button" {...rest}/>
};
